import { PartImageNarrowTarget } from '@/api/api';
import { PartImageCharacteristicQuestions, PartImageItemTypeOption } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const PART_IMAGE_CHARACTERISTIC_QUESTIONS_QUERY_KEY = 'partImageCharacteristicQuestions';

export const useGetPartImageCharacteristicQuestions = (
  identificationId: string,
  itemType?: PartImageItemTypeOption,
  target?: PartImageNarrowTarget
) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useQuery<PartImageCharacteristicQuestions, AxiosApiError>({
    queryKey: [PART_IMAGE_CHARACTERISTIC_QUESTIONS_QUERY_KEY, identificationId, itemType, target],
    queryFn: async () => {
      const response = await api.tenants.listPartImageCharacteristicQuestions(
        tenantId,
        identificationId,
        itemType,
        target
      );
      return response.data.characteristicQuestions;
    },
    enabled: !!tenantId,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
